// extracted by mini-css-extract-plugin
export default {"head":"Comments_head__Zn4ac","form":"Comments_form__v9DpI","title":"Comments_title__KhuXC"};